// Our main CSS
import '../css/app.css'


//Alpine js

import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()
